"use client";

import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import PlayerModal from "@/components/headToHead/PlayerStats/PlayerStatsTable/viewGameLog/PlayerModal";
import {
  prefetchGameLogAndStats,
  useGameLogAndStats,
} from "@/utils/hooks/useGetHeadToHeadPlayerGameLogAndStats";
import { useHeadToHeadContext } from "@/utils/hooks/useHeadToHeadContext";
import styles from "./viewGameLog.module.scss";

type ViewGameLogProps = {
  numberFirePlayerId: number;
  playerName: string;
};

const ViewGameLog = ({ numberFirePlayerId, playerName }: ViewGameLogProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const queryClient = useQueryClient();
  const { gameId } = useHeadToHeadContext();
  const { gameLogRefetch, gameStatsRefetch } = useGameLogAndStats(
    gameId,
    numberFirePlayerId
  );

  const toggleModal = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  const handleEnter = useCallback(() => {
    prefetchGameLogAndStats(queryClient, gameId, numberFirePlayerId);
  }, [queryClient, numberFirePlayerId, gameId]);

  const handleRefetch = useCallback(() => {
    gameLogRefetch();
    gameStatsRefetch();
  }, [gameLogRefetch, gameStatsRefetch]);

  const handleClick = useCallback(() => {
    handleRefetch();
    toggleModal();
  }, [handleRefetch, toggleModal]);

  return (
    <>
      <button
        onMouseEnter={handleEnter}
        onFocus={handleEnter}
        onClick={handleClick}
        className={styles.button}
      >
        View Game Log
      </button>
      <PlayerModal
        isOpen={isOpen}
        toggleModal={toggleModal}
        playerName={playerName}
        numberFirePlayerId={numberFirePlayerId}
        handleRefetch={handleRefetch}
      />
    </>
  );
};

export default ViewGameLog;
